import { Descriptions, Empty, Typography } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

const { Text } = Typography

/**
 * Renders a value the way a person reads it, not the way JSON prints it.
 * @param {*} value Any stored value.
 * @returns {string} Display string.
 */
const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

/**
 * The expanded row: what changed, and any extra context recorded with the event.
 *
 * `changes` is stored as {field: {from, to}} and only ever holds fields that
 * actually changed, so this renders every entry it is given.
 */
const AuditChanges = ({ record }) => {
  const changes = record?.changes
  const metadata = record?.metadata
  const changeEntries = changes ? Object.entries(changes) : []
  const metadataEntries = metadata ? Object.entries(metadata) : []

  if (!changeEntries.length && !metadataEntries.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No further detail was recorded for this entry"
      />
    )
  }

  return (
    <div style={{ padding: '4px 0' }}>
      {changeEntries.length > 0 && (
        <Descriptions
          title="What changed"
          size="small"
          column={1}
          bordered
          style={{ marginBottom: metadataEntries.length ? 16 : 0 }}
        >
          {changeEntries.map(([field, change]) => (
            <Descriptions.Item key={field} label={field}>
              <Text delete type="secondary">
                {formatValue(change?.from)}
              </Text>
              <Text strong style={{ margin: '0 8px' }}>
                →
              </Text>
              <Text>{formatValue(change?.to)}</Text>
            </Descriptions.Item>
          ))}
        </Descriptions>
      )}

      {metadataEntries.length > 0 && (
        <Descriptions title="Details" size="small" column={2} bordered>
          {metadataEntries.map(([key, value]) => (
            <Descriptions.Item key={key} label={key}>
              {formatValue(value)}
            </Descriptions.Item>
          ))}
        </Descriptions>
      )}
    </div>
  )
}

AuditChanges.propTypes = {
  record: PropTypes.shape({
    changes: PropTypes.object,
    metadata: PropTypes.object,
  }).isRequired,
}

export default AuditChanges
